import { onMounted } from 'vue';

const DEFAULT_MEASUREMENT_ID = 'UA-126115916-1';

interface WindowWithGtag extends Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
}

let initialized = false;

function createExternalScript(measurementId: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    return script;
}

export function useGtagWidget(measurementId: string = DEFAULT_MEASUREMENT_ID) {
    const win = window as unknown as WindowWithGtag;

    onMounted(() => {
        if(initialized || win.dataLayer) {
            return;
        }
        initialized = true;

        win.dataLayer = win.dataLayer || [];
        win.gtag = win.gtag || function gtag(...args: unknown[]) {
            win.dataLayer?.push(args);
        };

        document.head.appendChild(createExternalScript(measurementId));

        win.gtag('js', new Date());
        win.gtag('config', measurementId);
    });
}
